import { Injectable } from '@angular/core';
import { Observable, Subject, finalize, shareReplay, tap } from 'rxjs';
import { ApiService } from './api.service';

export type ContactDetail = 'email' | 'phone' | 'whatsapp';
export interface ViewedContact {
  detail: ContactDetail;
  value: string;
  countryCode: string | null;
  isViewed: boolean;
}

@Injectable({ providedIn: 'root' })
export class CandidateContactService {
  private readonly pending = new Map<string, Observable<ViewedContact>>();
  private readonly revealed = new Subject<{ vacancyId: string; talentId: string; contact: ViewedContact }>();
  readonly revealed$ = this.revealed.asObservable();

  constructor(private api: ApiService) {}

  view(vacancyId: string, talentId: string, detail: ContactDetail): Observable<ViewedContact> {
    const key = `${vacancyId}:${talentId}:${detail === 'email' ? 'email' : 'phone'}`;
    const existing = this.pending.get(key);
    if (existing) return existing;
    const request = this.api.viewCandidateContact(vacancyId, talentId, detail).pipe(
      tap(contact => this.revealed.next({ vacancyId, talentId, contact })),
      finalize(() => this.pending.delete(key)),
      shareReplay({ bufferSize: 1, refCount: false }),
    );
    this.pending.set(key, request);
    return request;
  }
}
